import { useEffect } from "react";

import MainLayout from "@/pages/layouts/MainLayout";
import { PageActions } from "@/pages/layouts/components/PageActions";
import { useAppContext } from "@/shared/hooks/useAppContext";
import PeopleList from "./components/PeopleList";
import { trackEvent, EventType } from "@/shared/utils/core";

export default function People() {
  const { person } = useAppContext();

  useEffect(() => {
    trackEvent(EventType.PEOPLE_SECTION_ACCESSED, {
      entry_point: "navigation",
    });
  }, []);

  const deceasedUserData = {
    firstName: person?.first_name || "",
    displayName: person?.nickname || person?.first_name || "",
    surName: person?.last_name || "",
  };

  return (
    <MainLayout header="Contacts" actions={<PageActions />}>
      <div className="flex flex-col w-full gap-6">
        <PeopleList deceasedUserData={deceasedUserData} />
      </div>
    </MainLayout>
  );
}
